import React from "react";

import { Typography } from "@mui/material";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { renderCostValue } from "../utilityFunctions";

const ProfitChangePercentage = ({ budgetData }) => {
    const current = budgetData?.current_contract_summary;
    const penultimate = budgetData?.penultimate_contract_summary;
    const percentChange = penultimate?.profit_percentage_change;

    if (!current || !penultimate) {
        return <Typography style={{ textAlign: 'center' }} className="ppsf-mini">--</Typography>;
    }

    const dollarChange =
        (current.projected_over_under ?? 0) - (penultimate.projected_over_under ?? 0);
    const safePercentChange =
        percentChange === undefined || percentChange === null ? 0 : percentChange;

    if (dollarChange === 0 && safePercentChange === 0) {
        return <Typography style={{ textAlign: 'center' }} className="ppsf-mini">--</Typography>;
    }

    const isPositive = dollarChange >= 0;
    const color = isPositive ? 'green' : 'red';
    const ArrowIcon = isPositive ? ArrowDropUpIcon : ArrowDropDownIcon;

    return (
        <Typography style={{ color: color, textAlign: 'center' }} className='ppsf-mini'>
            {`${renderCostValue(dollarChange)} [${safePercentChange.toFixed(2)}%]`}
            <ArrowIcon fontSize="small" style={{ marginLeft: '2px', verticalAlign: 'top' }} />
        </Typography>
    );
};

export default ProfitChangePercentage;
